module.exports = __webpack_public_path__ + "img/white.ce747e14.svg";